const state = () => ({
  sidebarIsShown: true,
  backRouteName: '',
  manifest: {},
  pwaIsStarted: false,
  gtmIsCreated: false,
  notificationCategoryGroups: [],
  notificationCategories: [],
  isSidebarShown: true,
  applicationIsAuth: false,
  applicationDataFetched: false,
  isMiniSidebarShown: false,
  maxCampaignUpdatingRuleConditions: null,
  campaignUpdatingRuleTypes: [],
  campaignUpdatingRuleConditionFields: [],
  campaignUpdatingRuleOperations: ['greater', 'equal', 'less'],
  loading: false,
  clientAdFormats: [],
  adFormatGroups: [],
  placementTypes: [],
  limitTypes: ['money', 'impressions', 'clicks'],
  defaultUniquesCap: null,
  defaultUniquesTtl: null,
  connectionTypes: [
    { type: 'all', name: 'All types' },
    { type: 'wifi', name: 'LAN & Wi-Fi' },
    { type: 'accept', name: 'Mobile carriers' }
  ],
  locale: 'en',
  locales: [
    { value: 'en', label: 'English', flagIcon: '$en-flag' },
    { value: 'ru', label: 'Русский', flagIcon: '$ru-flag' },
    { value: 'es', label: 'Español', flagIcon: '$es-flag' },
    { value: 'de', label: 'Deutsch', flagIcon: '$de-flag' },
    { value: 'jp', label: '日本語', flagIcon: '$jp-flag' }
  ],
  minLimitInMoney: null,
  minLimitInImpressions: null,
  minLimitInClicks: null,
  maxWebPushSubscriptionDays: null,
  maxSessionCount: 50,
  maxKaminaryScore: 0,
  companyCardIoLink: '',
  cardIoLink: '',
  undefinedSiteId: '',
  undefinedSpotId: '',
  smartBiddingByAdFormat: {},
  serverTime: '',
  minAddFundsAmount: null,
  twoFactorAuthenticationMethods: [],
  apiTokenScopes: [],
  paymentMethods: [],
  cardVerificationRequiredForPayments: false,
  limitTypesByPricingModel: {},
  adTypes: {},
  adsDataRequirements: {
    iosCalendar: {
      title: 60,
      description: 160
    },
    push: {
      title: 25,
      bodyWithoutImage: 100,
      bodyWithImage: 35
    },
    directLink: {
      title: 18
    },
    gallery: {
      contentFeedName: 23
    },
    nativeAd: {
      title: 45,
      description: 80
    }
  },
  defaultRotationHoursThreshold: null,
  defaultRotationImpressionsThreshold: null,
  directLinkIcons: [],
  inStreamAdSkipTimeOptions: [],
  mediaFileSizeLimits: {},
  trafficChartPricingModels: [],
  trafficQualityTypes: [],
  rotationTypes: [],
  adNetwork: {
    adFormats: [],
    name: '',
    guardSections: [],
    targetTypes: [],
    showSiteDomains: true,
    showPaymentCabinetDetalization: false,
    crispWebsiteId: null,
    settings: {
      channelsSettings: {},
      apiSelect: '',
      apiUrl: '',
      enablePwa: false,
      renameInPageFormat: false,
      themes: {},
      images: {},
      favicons: {},
      pwaFavicon: {},
      helpUrls: {},
      helpVideosUrls: {},
      dashboardGallery: false,
      spentThisWeek: false,
      showVerificationBanner: true,
      payments: false,
      enableReferralBanners: false,
      referralBanners: {},
      gtmId: '',
      locales: [],
      welcomeScreen: {
        type: 'three-screen',
        imageUrl: '',
        videoUrl: ''
      },
      liveChat: {
        type: '',
        intercom: {},
        tawk: {}
      },
      ioLink: '',
      adsSpots: {
        marketplace: { type: null },
        dashboardFirst: { type: null },
        dashboardSecond: { type: null },
        dashboardThird: { type: null },
        dashboardFourth: { type: null },
        sidebarWidget: { type: null }
      },
      inPagePreviewTagId: null,
      stripeRedirectUrl: '',
      enablePanvyDetails: false,
      defaultAdFormatTargets: {},
      orderAdFormatSortingGroups: [],
      orderAdFormatTypes: [],
      currencySignIsShown: false,
      addFundsPresets: [],
      stripePresets: []
    }
  },
  trafficProviderMethodTypes: [],
  trafficProviderPricingModels: [],
  trafficProviderVerticalTypes: [],
  flatDealAdFormatIds: [],
  flatDealCountryGroups: [],
  flatDealDefaultLimitType: null,
  flatDealDefaultValueKey: null,
  flatDealTiers: [],
  flatDealTrafficTypes: [],
  flatDealApplicationLimitTypes: [],
  trafficQualityTypesName: [
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' }
  ],
  providerMethodTypes: [
    { value: 'xml', text: 'XML' },
    { value: 'rtb', text: 'oRTB' }
  ],
  defaultInPageSkinId: null
})

export default state
